import { WatchIllustration } from '@carboncopyco/illustrations';
import { Button, Modal, TextBase, TextSubHeader } from '@carboncopyco/ui';
import { useEffect } from 'react';
import { useFocusAppService } from '../../hooks/useFocusAppService';
import { useAnalyticsSession } from '../../store/context/AnalyticsSessionContext';

export const SessionIdleModal = () => {
  const { isSessionIdle, forClient, onDestroy, onResume } =
    useAnalyticsSession();

  const { triggerFocus } = useFocusAppService();

  useEffect(() => {
    if (isSessionIdle) {
      triggerFocus(isSessionIdle);
      return;
    }
    triggerFocus(false);
  }, [isSessionIdle]);

  return (
    <Modal
      locked
      removeCloseIcon
      open={isSessionIdle}
    >
      <div className="p-12 flex justify-center items-center bg-ds-accent3-100 rounded-md  max-w-[600px]">
        <div className="gap-6 flex items-center flex-col text-center">
          <WatchIllustration />
          <TextSubHeader
            color="text-ds-natural-600"
            label={`Session for ${forClient} has ended`}
          />
          <TextBase
            color="text-ds-natural-600"
            label="You've been inactive for more than 45 minutes."
          />
          <div className="flex flex-col gap-6">
            <Button
              label="Go to Demostack"
              onClick={onDestroy}
            />
            <Button
              blue
              link
              label="Continue demo"
              onClick={onResume}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
